import { render, staticRenderFns } from "./HeaderHabitat.vue?vue&type=template&id=f0c6a09a&scoped=true&"
import script from "./HeaderHabitat.vue?vue&type=script&lang=js&"
export * from "./HeaderHabitat.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHabitat.vue?vue&type=style&index=0&id=f0c6a09a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6a09a",
  null
  
)

export default component.exports